export default "__VITE_ASSET__BHJbwi8o__"